export class LoadMyProfileAction {
  static readonly type = '[Profile] Load My Profile';
}

export class UpdateProfileAction {
  static readonly type = '[Profile] Update Profile';

  constructor(public payload) { }
}